module.exports = __webpack_public_path__ + "img/upwork-review-6.a44ed62c.jpg";